import React from 'react';
import { motion } from 'framer-motion';

const Preloader = () => {
    // Styles matching AnimatedText closely
    const textStyle = {
        fontFamily: '"Playfair Display", serif',
        fontWeight: 'normal',
        color: '#000',
        textAlign: 'center',
        letterSpacing: '15px', // Match AnimatedText desktop initial
        margin: 0,
        // Responsive sizing roughly matching AnimatedText base logic
        fontSize: 'clamp(28px, 5vw, 80px)',
    };

    return (
        <motion.div
            initial={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 1.5, ease: "easeInOut" } }} // Slow exit
            style={{
                position: 'fixed',
                inset: 0,
                backgroundColor: '#fff',
                zIndex: 99999,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                pointerEvents: 'none' // Allow clicks to pass through during fade out if visible
            }}
        >
            <motion.h1
                style={textStyle}
                animate={{
                    opacity: [0.5, 1, 0.5],
                    scale: [0.98, 1.02, 0.98],
                }}
                transition={{
                    duration: 2.5,
                    ease: "easeInOut",
                    repeat: Infinity,
                }}
            >
                Royal Sofás
            </motion.h1>
        </motion.div>
    );
};

export default Preloader;
